import { ContentPageLayout } from '@components';
import { ContentBlock } from '@components/blocks/content/ContentBlock/ContentBlock';

export const ExamplePage = () => (
  <ContentPageLayout>
    <ContentBlock title='Route in React'>
      Example page. This was created entirely in React
    </ContentBlock>
  </ContentPageLayout>
);
